import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchDialogService {
  private _open$ = new Subject<void>();
  open$ = this._open$.asObservable();

  open(): void {
    this._open$.next();
  }
}
